import React from "react";
import { sendPreAuthAudit } from "../../shared/helpers";
import { Auth } from "aws-amplify";

export async function executeLogin(loginData: any, setUser: React.Dispatch<any>, setAuthFlowErrorType: React.Dispatch<string>, setAuthFlowError: React.Dispatch<string>) {
    const userName = loginData.userName.trim();
    const password = loginData.password.trim();

    try {
        try {
            await sendPreAuthAudit(userName, "Login Attempt", `${userName} attempted to log into CARES dashboard`);
        } catch (err) {
            console.error(`Failed login attempt audit ${err}`)
        }
        const userSession = await Auth.signIn(userName, password, { 'product_scope': 'mc' });
        console.log('debug token refresh userSession: ', userSession)
        setUser(userSession);
        console.log(`Audit login attempt: ${userName}`);
        return userSession;

    } catch (err: any) {
        try {
            await sendPreAuthAudit(userName, "Login Bad Password", `${userName} failed password step in CARES dashboard`);
        } catch (err) {
            console.error(`Failed login attempt audit ${err}`)
        }
        setAuthFlowErrorType(err.code)
        setAuthFlowError(err.message);
        return { errorMessage: err.message, errorCode: err.code };
    }

}